import {
  Box,
  BoxProps,
  chakra,
  ColorProps,
  Flex,
  Heading,
} from '@chakra-ui/react'
import React from 'react'

// noinspection ES6PreferShortImport
import { CustomScrollbar, CustomScrollbarProps } from '../Misc/CustomScrollbar'
interface CardTitleProps {
  color?: ColorProps['color']
  uppercase?: boolean
}
export const CardTitle: React.FC<CardTitleProps> = ({
  children,
  color = 'deepPurple',
  uppercase,
}) => (
  <Heading
    className="card-title"
    color={color}
    flexGrow={1}
    fontWeight="700"
    size="lg"
    textTransform={uppercase ? 'uppercase' : 'none'}
  >
    {children}
  </Heading>
)

const sxCardSubTitle = {
  'span:not(:first-child)': {
    color: 'neutral.90',
  },
}

export const CardSubTitle: React.FC<BoxProps> = ({ children }) => (
  <Box
    className="card-subtitle"
    color="neutral.90"
    fontSize="md"
    sx={sxCardSubTitle}
  >
    {children}
  </Box>
)

export interface CardProps extends CustomScrollbarProps {
  center?: boolean
  error?: boolean
  fit?: boolean
  fullHeight?: boolean
  fullSize?: boolean
  fullWidth?: boolean
  scrollable?: boolean
  statusColor?: ColorProps['color']
  withMargins?: boolean
}

const CustomScrollbarInherited = chakra(CustomScrollbar)
export const Card: React.FC<CardProps> = ({ children, ...props }) => {
  const {
    center,
    error,
    fit,
    fullHeight,
    fullSize,
    fullWidth,
    scrollable,
    statusColor,
    withMargins,
    ...rest
  } = props

  return (
    <CustomScrollbarInherited
      bg="white.0"
      border="1px solid"
      borderColor={error ? 'red.70' : 'neutral.20'}
      borderLeft={statusColor ? '8px solid' : undefined}
      borderLeftColor={statusColor}
      borderRadius="4px"
      boxShadow="0 1px 4px 0 rgba(0, 0, 0, 0.05)"
      className="card"
      height={
        fullHeight || fullSize
          ? withMargins
            ? 'calc(100% - 20px)'
            : '100%'
          : 'auto'
      }
      mb={5}
      mx={center ? 'auto' : undefined}
      overflowY={scrollable ? 'auto' : undefined}
      p={5}
      sx={{
        '& > *:not(:last-child)': {
          marginBottom: withMargins ? '12px' : undefined,
        },
      }}
      width={fullWidth || fullSize ? '100%' : fit ? 'fit-content' : 'auto'}
      {...rest}
    >
      {children}
    </CustomScrollbarInherited>
  )
}

const sxCardTitleContainer = {
  '.card-title + .card-subtitle': {
    marginTop: 1,
  },
}

export const CardTitleContainer: React.FC<BoxProps> = props => (
  <Box
    className="card-title-container"
    marginBottom={5}
    sx={sxCardTitleContainer}
    {...props}
  />
)

interface CardFooterProps {
  reverse?: boolean
  withoutMargins?: boolean
}
export const CardFooter: React.FC<CardFooterProps> = ({
  children,
  reverse,
  withoutMargins,
}) => (
  <Flex
    borderTop="1px solid"
    borderTopColor="neutral.20"
    m="20px -20px 0"
    p="20px 20px 0"
    sx={{
      '& > *:not(:last-child)': {
        [reverse ? 'marginLeft' : 'marginRight']: withoutMargins
          ? undefined
          : '20px',
      },
    }}
  >
    {children}
  </Flex>
)
